import { Button } from "@/src/components/v2/Button/Button";
import React, { useState } from "react";
import { BrandService } from "@/src/BrandService";

const Calculator = ({ total }: { total: number }) => {
    const [activeButton, setActiveButton] = useState(0.9);
    const samplePolicyLink = BrandService.getCurrentBrandData().samplePolicyLink;

    const handleClick = (val: number) => {
        setActiveButton(val);
    };

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return (
        <div className="md:max-w-[296px]" style={{ flex: `0 0 296px` }}>
            <div className="Calculator overflow-hidden rounded-3xl border border-border-light shadow-md ">
                <div className="Calculator-header bg-info-light pt-6 pb-4 text-center text-text-primary">
                    <p className="text-overline font-bold uppercase tracking-overline">Eligible vet bill</p>
                    <p className="mt-1 text-lg font-bold tracking-lg">{formatter.format(total)}</p>
                </div>
                <div className="Calculator-body px-6 pt-6 pb-4 text-center">
                    <p className="mb-2 text-overline font-bold uppercase tracking-overline">Reimbursement Rate</p>
                    <div className="Calculator-tabs flex justify-center">
                        <div className="tabs mb-7 justify-center overflow-hidden rounded-3xl bg-background-medium text-text-primary">
                            <button
                                className={`tab h-[unset] px-4 pt-2 pb-2 text-body2 font-bold tracking-body2 transition ${
                                    activeButton === 0.7 ? `tab-active !text-contrast !rounded-none !bg-accent-primary-ada !text-text-contrast` : ``
                                }`}
                                value={0.7}
                                onClick={() => handleClick(0.7)}
                            >
                                70%
                            </button>
                            <button
                                className={`tab h-[unset] px-4 pt-2 pb-2 text-body2 font-bold tracking-body2 transition ${
                                    activeButton === 0.8 ? `tab-active !text-contrast !rounded-none !bg-accent-primary-ada !text-text-contrast` : ``
                                }`}
                                value={0.8}
                                onClick={() => handleClick(0.8)}
                            >
                                80%
                            </button>
                            <button
                                className={`tab h-[unset] px-4 pt-2 pb-2 text-body2 font-bold tracking-body2 transition ${
                                    activeButton === 0.9 ? `tab-active !text-contrast !rounded-none !bg-accent-primary-ada !text-text-contrast` : ``
                                }`}
                                value={0.9}
                                onClick={() => handleClick(0.9)}
                            >
                                90%
                            </button>
                        </div>
                    </div>
                    <div className="mx-auto flex max-w-[230px] flex-col items-center text-center">
                        <p className="mx-auto mb-2 text-overline font-bold uppercase  tracking-overline">Amount a Spot accident &amp; illness plan could cover*</p>
                        <p className="mx-auto mb-5 text-center text-md font-bold tracking-md  text-text-secondary">{formatter.format(total * activeButton)}</p>
                        <p className="mx-auto mb-2 text-overline font-bold uppercase  tracking-overline">Your Net payment</p>
                        <p className="mx-auto mb-5 text-center text-lg font-bold tracking-lg  text-text-secondary">{formatter.format(total * (1 - activeButton))}</p>
                        <Button href="/quote" title="Click For Price" style="Primary" addArrow />
                    </div>
                </div>
            </div>
            <p className="Calculator-terms mt-4 mb-7 text-center text-caption tracking-caption text-text-primary">
                *Hypothetical reimbursement examples illustrate reimbursement of an eligible vet bill at the noted reimbursement rate, assuming the annual deductible had already
                been satisfied and the annual coverage limit has not yet been met. Annual deductible, co-insurance, benefit and coverage limits, and exclusions may apply.
                Eligibility may vary. Visit {samplePolicyLink} for full terms. For Canada enrollments only, reimbursement rate is based on the pet&apos;s age.
            </p>
        </div>
    );
};

export default Calculator;
